/** @jsxImportSource theme-ui */
import { Formik } from 'formik'
import Link from 'next/link'
import React from 'react'
import { Box, Button, Card, Flex, Input, Spinner, Text } from 'theme-ui'
import * as Yup from 'yup'
import { signIn } from 'next-auth/react'
import toast from 'react-hot-toast'

type Props = {
  setActiveForm: (value: string) => void
}

function LoginForm({ setActiveForm }: Props) {
  const onLogin = async (values: any) => {
    const formData = {
      email: values.email,
      password: values.password,
    }

    try {
      const response = await signIn('shopify', {
        ...formData,
        redirect: false,
      })

      if (!response?.ok) {
        toast.error('Email or password incorrect')
        return
      }

      // log in to shopify with multipass
      const authResponse = await fetch('/api/shopify/auth')
      const authData: any = await authResponse.json()
      if (authResponse.status === 307) {
        toast.success('Logged in successfully');
        window.location = authData.redirect_url || ''
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Flex sx={{ flexDirection: 'column' }}>
      <Text
        sx={{
          fontSize: [5, 6],
          textAlign: 'center',
          mb: 4,
          width: '100%',
        }}
      >
        Login
      </Text>
      <Card
        sx={{
          px: [3, 5],
          py: [4, 6],
          boxShadow: 'header',
          bg: 'background',
          borderRadius: 3,
        }}
      >
        <Formik
          initialValues={{ email: '', password: '' }}
          validationSchema={Yup.object({
            email: Yup.string()
              .email('Invalid email address')
              .required('Required'),
            password: Yup.string().required('Required'),
          })}
          onSubmit={onLogin}
        >
          {(formik: any) => (
            <form onSubmit={formik.handleSubmit} style={{ marginBottom: 0 }}>
              <Box>
                <Flex sx={{ display: ['block'] }}>
                  <Box sx={{ marginBottom: 3, flex: [null, 1] }}>
                    <Input
                      type="Email"
                      placeholder="Email Address"
                      {...formik.getFieldProps('email')}
                      sx={{ borderColor: 'border' }}
                    />
                  </Box>
                  <Box sx={{ marginBottom: 3, flex: [null, 1] }}>
                    <Input
                      type="Password"
                      placeholder="Password"
                      {...formik.getFieldProps('password')}
                      sx={{ borderColor: 'border' }}
                    />
                  </Box>
                </Flex>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {formik.isSubmitting && <Spinner />}
                {!formik.isSubmitting && (
                  <Button
                    variant="primary"
                    type="submit"
                    sx={{
                      borderRadius: (t: any) => t.radii[3],
                      width: '100%',
                    }}
                    disabled={formik.isSubmitting}
                  >
                    Login
                  </Button>
                )}
              </Box>
              <Box>
                <Flex
                  sx={{
                    mt: 3,
                    justifyContent: 'space-between',
                  }}
                >
                  <Link
                    href="/account/register"
                    style={{ textDecoration: 'none' }}
                  >
                    <Text
                      sx={{
                        fontSize: 1,
                        color: 'text',
                        textAlign: 'center',
                        width: '100%',
                        cursor: 'pointer',
                      }}
                    >
                      Create account
                    </Text>
                  </Link>
                  <Link
                    href="#"
                    style={{ textDecoration: 'none' }}
                    onClick={() => {
                      setActiveForm('reset')
                    }}
                  >
                    <Text
                      sx={{
                        fontSize: 1,
                        color: 'text',
                        textAlign: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      Forgot your password?
                    </Text>
                  </Link>
                </Flex>
              </Box>
            </form>
          )}
        </Formik>
      </Card>
    </Flex>
  )
}

export default LoginForm
